module.exports = __webpack_public_path__ + "img/polygon-selected.svg";